
export interface SmpaConfig {
	targets: TargetsStyle;
	targetFvg: TargetFvgToolStyle;
	targetBuildUp: TargetBuildUpToolStyle;
	targetSwng: TargetFvgToolStyle;
	poi: PoiToolStyle;
	pd: PDToolStyle;
	sweep: SweepToolStyle;
	raid: RaidToolStyle;
	fvg: FvgToolStyle;
	level: LevelToolStyle;
	eqLiq: BuildUpToolStyle;
	caLiq: BuildUpToolStyle;

	open: OpenToolStyle;
	sessions: SessionsStyle;
	struct: StructStyle;
	infoBox: InfoBoxStyle;
	alerts: AlertMarkUpStyle;
}

export interface ToolStyle {
	on: boolean;
}
export enum TxtAlign {
	Right = 0,
	Center = 1,
	Left = 2,

}
export interface TextStyleProps {
	txtOp: number;
	txtOn: boolean;
	txtUC: boolean;
	txtAl: TxtAlign;
	txtSz: number;
	pfx: string;
}
export interface TextStyle extends ToolStyle, TextStyleProps {

}

export interface MonoColorStyleProps {
	col: string;
}
export interface BiColorStyleProps {
	buCol: string;
	beCol: string;
}
export interface BiColorStyle extends TextStyle, BiColorStyleProps {
}
export interface MonoColorStyle extends TextStyle, MonoColorStyleProps {
}
export enum FvgExtend {
	ByTest,
	ByRT,
	No
}
export enum PoiExtend {
	ByStart,
	ByEnd,
	ByClosestPrice,
	ByTestOrRT,
	ByRT,
	No
}
export enum PoiType {
	//Either = 0,
	Primary = 1,
	Slave = 2,
	Both = Primary | Slave,
}
export enum PoiStyle {
	Blocks,
	Lines,
}
export enum PoiPreferences {
	Refine,
	Orig,
	Both
}
export enum TxtFlgs {
	Prefix = 0,
	Ids = 1,
}

export enum SweepTxtFlgs {
	Prefix = TxtFlgs.Prefix,
	Ids = TxtFlgs.Ids,
	QMs = 2,
	Levels = 4,
	Ids_QMs = Ids | QMs,
	Ids_Levels = Ids | Levels,
	QMs_Levels = QMs | Levels,
	All = Ids | QMs | Levels,
}
export enum RaidTxtFlgs {
	Prefix = TxtFlgs.Prefix,
	Ids = TxtFlgs.Ids,
	Levels = SweepTxtFlgs.Levels,
	All = Ids | Levels,
}
export enum PoiTxtFlgs {
	Prefix = TxtFlgs.Prefix,
	Ids = TxtFlgs.Ids,
	Levels = SweepTxtFlgs.Levels,
	Ids_Levels = Ids | Levels,
}
export enum TargetsTxtFlgs {
	Prefix = TxtFlgs.Prefix,
	Ids = TxtFlgs.Ids,
	Tools = SweepTxtFlgs.QMs,
}

export enum LineWidth {
	w0,
	w1 = 1,
	w2,
	w3,
	w4
}
export enum LineStyle {
	none = -1,
	solid = 0,
	dotted = 1,
	dashed = 2,
	largeDashed = 3
}

export interface LineStyleProps {
	lWidth: LineWidth;
	lStyle: LineStyle;
}

export interface PoiItemStyle extends BiColorStyle, LineStyleProps {
	txtFlgs: PoiTxtFlgs;
	ext: PoiExtend;
	style: PoiStyle;
	
}

//export interface OldPoiItemStyle extends PoiItemStyle {
//	prefs: PoiPreferences;
//}

export interface SbPoiItemStyle extends PoiItemStyle {
	hideOnRefine: boolean;
}

export enum PoiSignificance {
	Ignore = 0,
	AnyFvg = 1,
	AnySweep = 2,
	SweepPv5 = 4,
	SweepSwng = 8,
	SweepEq = 16,
	SweepCa = 32,
	Structured = 64,
	Reversal = 128
}
export enum PoiStyleType {
	HistoryPos,
	BlockType
}
export interface PoiToolStyle extends ToolStyle {
	//lb: OldPoiItemStyle;
	//ol: OldPoiItemStyle;
	//mr: OldPoiItemStyle;

	mb: PoiItemStyle;
	bb: PoiItemStyle;
	ob: PoiItemStyle;
	sb: SbPoiItemStyle;

//	by: PoiStyleType;

	maxol: number;

	s: PoiSignificance;
}
export interface WatermarkStyle extends ToolStyle {
	col: string;
}
export interface LineToolStyle extends BiColorStyle, LineStyleProps {

}
export interface LevelToolStyle extends LineToolStyle {
	day: boolean;
	week: boolean;
	month: boolean;
}

export interface BuildUpItemToolStyle extends ToolStyle, TextStyleProps, LineStyleProps, BiColorStyleProps {
	txtFlgs: TxtFlgs;
}
export enum PivotSignificance {
	Ignore = 0,
	SwingPv = 1,
	LevelPv = 2,
	SessionPv = 4,
	SweepPv = 8,
	AnyFvg = 16,
	Pv5 = 32,
}

export interface BuildUpToolStyle extends ToolStyle {
	dk: number;
	
	extd: BuildUpItemToolStyle;
	swept: BuildUpItemToolStyle;
	unswept: BuildUpItemToolStyle;
	s: PivotSignificance;
}


export interface OpenToolStyle extends MonoColorStyle, LineStyleProps {
	day: boolean;
	ny: boolean;
	week: boolean;
	month: boolean;
}
export interface RaidableToolStyle extends BiColorStyle, LineStyleProps {
}
export interface SweepToolStyle extends RaidableToolStyle {
	txtFlgs: SweepTxtFlgs;
}
export interface RaidToolStyle extends RaidableToolStyle {
	txtFlgs: RaidTxtFlgs;
}
export enum PDStyle {
	Blocks,
	Line,
}
export interface PDToolStyle extends ToolStyle, TextStyleProps, LineStyleProps {
	premCol: string;
	discCol: string;
	style: PDStyle;
}
export interface FvgToolStyle extends BiColorStyle {
	txtFlgs: TxtFlgs;
	buUPFCol: string;
	beUPFCol: string;
	buFCol: string;
	beFCol: string;
	buFFCol: string;
	beFFCol: string;
	upf: boolean;
	ff: boolean;
	ext: FvgExtend;
	extFByU: boolean;
	extFF: FvgExtend;
	//fill: boolean;
	//fillColor: number;
}
export interface TargetsStyle extends LineToolStyle {
	txtFlgs: TargetsTxtFlgs;
	/*	preview: boolean;*/
	max: number;

	//type: PoiType;
	//nearBy: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TargetToolStyle extends ToolStyle {
}
export interface TargetFvgToolStyle extends TargetToolStyle {
	fvgDist: number;
}
export interface TargetBuildUpToolStyle extends TargetFvgToolStyle {
	dist: number;
}

export interface MaxPivotsProps {
	max: number;
	parents: number;
}
export interface SizeProps {
	size: number;
	off: number;
}
export interface StructBaseStyle extends ToolStyle {
}
export interface StructTrendStyle extends StructBaseStyle, LineStyleProps {
}
export interface StructBosStyle extends StructBaseStyle, TextStyleProps, LineStyleProps, MaxPivotsProps {
	revname: string;
	bosname: string;
	showrev: boolean;
	showbos: boolean;
}
export interface StructLevelStyle extends TextStyleProps, LineStyleProps {
	on: boolean;
}

export enum PivotType {
	Tick,
	Circle,
	Triangle,
}
export enum PivotTxtFlgs {
	HH = 1,
	H = 2,
	Level = 4,
	HH_Level = HH | Level,
	H_Level = H | Level,
}

export interface StructPivotStyle extends StructBaseStyle, TextStyleProps, MaxPivotsProps, SizeProps {
	type: PivotType;
	flgs: PivotTxtFlgs;
}


export interface StructMoveStyle {
	on: boolean;

	bos: StructBosStyle;
	trend: StructTrendStyle;
	pivot: StructPivotStyle;


	buCol: string;
	beCol: string;
}
export interface StructSwingStyle extends StructMoveStyle {
	fbos: boolean;
	lvl: StructLevelStyle;
}
export interface StructFractalStyle extends StructMoveStyle {
}
export enum MinorLabelsOverlap {
	No,
	Combine
}
export enum MinorTxtStyle {
	Letter,
	Rome,
	Digit
}
export interface StructSwingStyles {
	major: StructSwingStyle;
	minors: StructSwingStyle[];
	minorTxtStyle: MinorTxtStyle;
	labover: MinorLabelsOverlap;
}
export interface StructStyle extends ToolStyle {
	pon: boolean;
	simple: StructFractalStyle;
	fractal: StructFractalStyle;
	swing: StructSwingStyles;
}
export interface SessionsStyle extends ToolStyle, TextStyleProps {
	aCol: string;
	ffCol: string;
	loCol: string;
	nyCol: string;
}

export interface InfoBoxStyle extends BiColorStyleProps {
	
}

export interface AlertMarkUpStyle extends MonoColorStyle, LineStyleProps {
	all: boolean;
}
